import {
  GOOGLE_MAPS_API_LOADED,
  RESET_MAP_LOCATION,
  SELECT_VIEW_LIST_MODE_JOB,
  SET_CLUSTERED_MAP,
  UPDATE_COVERAGE_AREA_LEVEL_ONE,
  UPDATE_MAP_LOCATION,
} from "./mapReducer";

export function updateMapLocation(location) {
  return {
    type: UPDATE_MAP_LOCATION,
    payload: location,
  };
}

export function resetMapLocation() {
  return {
    type: RESET_MAP_LOCATION,
  };
}

export function selectViewListModeJob(jobId) {
  return {
    type: SELECT_VIEW_LIST_MODE_JOB,
    payload: jobId,
  };
}

export function setClusteredMap(bool) {
  return {
    type: SET_CLUSTERED_MAP,
    payload: bool,
  };
}

export function updateCoverageAreaLevelOne(areaLevelOne) {
  return {
    type: UPDATE_COVERAGE_AREA_LEVEL_ONE,
    payload: areaLevelOne,
  };
}

export function googleMapsApiLoaded() {
  return {
    type: GOOGLE_MAPS_API_LOADED,
  };
}
